angular.module('unica_partner.partner_services')

.factory('PartnerListService', function ($http, getBaseApiURL) {

	var partnerListService = {};

	partnerListService.list = function (limit, offset)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/partner/list',
			data: {
				limit: limit,
				offset: offset
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.partners;
			}

		});

	};

	partnerListService.fullList = function ()
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/partner/full-list',
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.partners;
			}

		});
	};

	partnerListService.get = function (partnerId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/partner/detail/' + partnerId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.partner;
			}

		});
	};

	return partnerListService;
});